var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"international-parcel-enquiry"}},[_c('p',[_vm._v("Please give a brief description of the reason for your enquiry")]),_vm._v(" "),_c('EmailFormInput'),_vm._v(" "),_c('SubmitButton',{attrs:{"btnText":"Submit Enquiry"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd496fb8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/InternationalParcelEnquiry.vue
// module id = 73
// module chunks = 0